import 'modaal'
;(function($) {
	/*
	$('#more').on('click', function(e) {
		e.preventDefault()
		$('#preview').toggleClass('citoyens__preview')
		$('html, body').animate(
			{
				scrollTop: $('#more').offset().top - 140,
			},
			500
		)
	})
	*/
	$('.gallery').modaal({
		type: 'image',
		background: '#000',
		outer_controls: true,
		overlay_opacity: '0.95',
	})

	$('.zoom').modaal({
		type: 'image',
		background: '#000',
		overlay_opacity: '0.95',
	})

	$('.single__small-link').on('click', function(e) {
		e.preventDefault()
		let tgt = $(this).attr('href')
		let $tgt = $(tgt)
		$('html, body').animate(
			{
				scrollTop: $tgt.offset().top - 140,
			},
			500
		)
	})
})(jQuery)
